<ng-template #archiveAction>
            <div class="messages-detail__header-actions">
              <button class="messages-workspace__secondary-button"
                type="button"
                (click)="toggleArchiveSelected()">
                {{ (showArchived() ? 'messagesWorkspace.actions.restore' : 'site.archive') | translate }}
              </button>
            </div>
</ng-template>
<app-modal-shell [fillContent]="mobileConversation()" [mobileHeaderActionsBelow]="true" [dismissLabel]="'general.close' | translate" (dismiss)="dismiss()">
  <div modalTitle
    class="messages-workspace__title">
    @if (mobileConversation()) {
      <button type="button" class="messages-back" (click)="backToList()"><span aria-hidden="true">‹</span> {{ 'messagesWorkspace.title' | translate }}</button>
    } @else { <h2>{{ (mobile() && composerOpen() ? 'messagesWorkspace.compose.title' : 'messagesWorkspace.title') | translate }}</h2> }
    <p>{{ 'messagesWorkspace.description' | translate }}</p>
  </div>

  <div modalHeaderActions
    class="messages-workspace__header-actions" [class.messages-workspace__header-actions--worker]="mobile()" [class.messages-workspace__header-actions--hidden]="mobile() && (composerOpen() || mobileConversation())">
    <button class="messages-workspace__secondary-button messages-workspace__archive-toggle"
      type="button"
      (click)="toggleArchived()">
      {{ (showArchived() ? 'messagesWorkspace.actions.hideArchived' : 'messagesWorkspace.actions.showArchived') | translate }}
    </button>
    <button class="messages-workspace__primary-button"
      type="button"
      (click)="openCompose()">
      @if (mobile()) { <span aria-hidden="true">+ </span> }{{ 'messagesWorkspace.actions.compose' | translate }}
    </button>
  </div>

  <div class="messages-workspace" [class.messages-workspace--conversation]="mobileConversation()" [class.messages-workspace--mobile-list]="mobile() && !conversationOpen() && !composerOpen()" [class.messages-workspace--worker-mobile]="mobile()" [class.messages-workspace--composing]="composerOpen()"
    [class.messages-workspace--unselected]="!composerOpen() && !selectedEntry()">
    <aside class="messages-workspace__sidebar" #mailbox>
      @if (mobile()) {
        <div class="messages-workspace__sidebar-tabs" role="group" [attr.aria-label]="'messagesWorkspace.title' | translate">
          @for (mailbox of ['inbox', 'sent', 'archive']; track mailbox) {
            <button type="button" class="messages-workspace__tab"
              [class.messages-workspace__tab--active]="mobileMailbox() === mailbox"
              [attr.aria-pressed]="mobileMailbox() === mailbox"
              (click)="selectMobileMailbox($any(mailbox))">
              {{ 'messagesWorkspace.folders.' + mailbox | translate }}
            </button>
          }
        </div>
      } @else {
      <div class="messages-workspace__sidebar-tabs">
        <button type="button"
          class="messages-workspace__tab"
          [class.messages-workspace__tab--active]="folder() === 'inbox'"
          (click)="onFolderChange('inbox')">
          {{ 'messagesWorkspace.folders.inbox' | translate }}
        </button>
        <button type="button"
          class="messages-workspace__tab"
          [class.messages-workspace__tab--active]="folder() === 'sent'"
          (click)="onFolderChange('sent')">
          {{ 'messagesWorkspace.folders.sent' | translate }}
        </button>
      </div>
      }

      <label class="messages-workspace__search">
        <ion-icon name="search-outline"></ion-icon>
        <input type="search"
          [value]="searchTerm()"
          [placeholder]="'messagesWorkspace.searchPlaceholder' | translate"
          (input)="searchTerm.set($any($event.target).value)" />
      </label>

      <div class="messages-workspace__list">
        @for (entry of listEntries(); track entry.key) {
          <button type="button"
            class="messages-workspace__list-item"
            [class.messages-workspace__list-item--active]="selectedEntryKey() === entry.key && !composerOpen()"
            (click)="selectEntry(entry)">
            <div class="messages-workspace__list-avatar"
              [class.messages-workspace__list-avatar--group]="entry.kind === 'group'">
              @if (entry.kind === 'group') {
                <ion-icon name="people-outline"></ion-icon>
              } @else {
                {{ getInitials(getEntrySubtitle(entry)) }}
              }
            </div>

            <div class="messages-workspace__list-copy">
              <div class="messages-workspace__list-row">
                <strong>{{ getEntryTitle(entry) }}</strong>
                <span>{{ entry.updatedAt | date:'dd.MM. HH:mm' }}</span>
              </div>
              <div class="messages-workspace__list-row">
                <small>{{ getEntrySubtitle(entry) }}</small>
                @if (getEntryUnread(entry)) {
                  <span class="messages-workspace__unread-dot"></span>
                }
              </div>
              <p>{{ getEntryPreview(entry) }}</p>
            </div>
          </button>
        } @empty {
          <div class="messages-workspace__sidebar-empty">
            @if (searchTerm().trim().length > 0) {
              <strong>{{ 'messagesWorkspace.empty.noSearchResultsTitle' | translate }}</strong>
              <p>{{ 'messagesWorkspace.empty.noSearchResultsDescription' | translate }}</p>
            } @else if (showArchived()) {
              <strong>{{ 'messagesWorkspace.empty.archivedTitle' | translate }}</strong>
              <p>{{ 'messagesWorkspace.empty.archivedDescription' | translate }}</p>
            } @else if (folder() === 'sent') {
              <strong>{{ 'messagesWorkspace.empty.sentTitle' | translate }}</strong>
              <p>{{ 'messagesWorkspace.empty.sentDescription' | translate }}</p>
            } @else {
              <strong>{{ 'messagesWorkspace.empty.inboxTitle' | translate }}</strong>
              <p>{{ 'messagesWorkspace.empty.inboxDescription' | translate }}</p>
            }
          </div>
        }
      </div>
    </aside>

    <section class="messages-workspace__detail">
      @if (composerOpen()) {
        <form class="messages-compose"
          [formGroup]="composeForm">
          <div class="messages-detail__header">
            <div>
              <p class="messages-detail__eyebrow">{{ 'messagesWorkspace.compose.eyebrow' | translate }}</p>
              <h3>{{ 'messagesWorkspace.compose.title' | translate }}</h3>
              <p>{{ 'messagesWorkspace.compose.description' | translate }}</p>
            </div>

            <div class="messages-detail__header-actions">
              <button class="messages-workspace__secondary-button"
                type="button"
                (click)="closeCompose()">
                {{ 'general.cancel' | translate }}
              </button>
              <button class="messages-workspace__primary-button"
                type="button"
                [disabled]="sending()"
                (click)="submitCompose()">
                {{ (mobile() && composeForm.controls.type.value === 'message' ? 'messagesWorkspace.actions.sendMessage' : 'general.send') | translate }}
              </button>
            </div>
          </div>

          <div class="messages-compose__grid">
            @if (isAdmin()) {
              <label class="messages-compose__field">
                <span>{{ 'messagesWorkspace.compose.audience' | translate }}</span>
                <app-select-popover overlayClass="messages-select-overlay" formControlName="audience">
                  <ion-select-option
                    value="single">{{ 'messagesWorkspace.audience.singleEmployee' | translate }}</ion-select-option>
                  <ion-select-option
                    value="selected">{{ 'messagesWorkspace.audience.selectedEmployees' | translate }}</ion-select-option>
                  <ion-select-option
                    value="all">{{ 'messagesWorkspace.audience.allEmployees' | translate }}</ion-select-option>
                </app-select-popover>
              </label>
            }

            <label class="messages-compose__field">
              <span>{{ 'messagesWorkspace.compose.type' | translate }}</span>
              <app-select-popover overlayClass="messages-select-overlay" formControlName="type">
                <ion-select-option
                  value="message">{{ 'messagesWorkspace.types.message' | translate }}</ion-select-option>
                @if (isAdmin()) {
                  <ion-select-option
                    value="announcement">{{ 'messagesWorkspace.types.announcement' | translate }}</ion-select-option>
                  <ion-select-option
                    value="system">{{ 'messagesWorkspace.types.system' | translate }}</ion-select-option>
                }
              </app-select-popover>
            </label>

            <label class="messages-compose__field messages-compose__field--full">
              <span>{{ 'messagesWorkspace.compose.titleField' | translate }}</span>
              <input type="text"
                formControlName="title"
                [placeholder]="'messagesWorkspace.compose.titlePlaceholder' | translate" />
            </label>

            @if (!isAdmin() || composeForm.get('audience')?.value === 'single') {
              <label class="messages-compose__field messages-compose__field--full">
                <span>{{ 'messagesWorkspace.compose.recipient' | translate }}</span>
                @if (currentUser()?.role === 'worker' && recipientOptions().length === 0) {
                  <span class="messages-compose__recipient-empty" role="status">{{ 'messagesWorkspace.compose.noManagementRecipients' | translate }}</span>
                } @else {
                  <app-select-popover overlayClass="messages-select-overlay" formControlName="recipientIds">
                    <ion-select-option value="" disabled selected>{{ 'messagesWorkspace.compose.selectRecipient' | translate }}</ion-select-option>
                    @for (user of recipientOptions(); track user.guid) {
                      <ion-select-option [value]="user.guid" [description]="currentUser()?.role === 'worker' ? ('users.roles.' + user.role | translate) : undefined">{{ user.displayName }}</ion-select-option>
                    }
                  </app-select-popover>
                }
              </label>
            } @else if (composeForm.get('audience')?.value === 'selected') {
              <div class="messages-compose__field messages-compose__field--full">
                <span>{{ 'messagesWorkspace.compose.searchRecipients' | translate }}</span>
                <div class="messages-compose__recipient-picker">
                  <label class="messages-compose__recipient-search">
                    <ion-icon name="search-outline"></ion-icon>
                    <input type="search"
                      [value]="recipientSearchTerm()"
                      [placeholder]="'messagesWorkspace.compose.searchRecipientsPlaceholder' | translate"
                      (input)="recipientSearchTerm.set($any($event.target).value)" />
                  </label>

                  @if (recipientSearchTerm().trim().length > 0) {
                    <div class="messages-compose__recipient-results">
                      @for (user of filteredRecipientOptions(); track user.guid) {
                        <button class="messages-compose__recipient-result"
                          type="button"
                          (click)="addRecipient(user.guid)">
                          <span>{{ user.displayName }}</span>
                          <small>{{ 'users.roles.' + user.role | translate }}</small>
                        </button>
                      } @empty {
                        <div class="messages-compose__recipient-empty">
                          {{ 'messagesWorkspace.empty.noSearchResultsDescription' | translate }}
                        </div>
                      }
                    </div>
                  }
                </div>

                <span>{{ 'messagesWorkspace.compose.recipients' | translate }}</span>
                <div class="messages-compose__selected-list">
                  @for (user of selectedComposeRecipients(); track user.guid) {
                    <div class="messages-compose__selected-item">
                      <div>
                        <strong>{{ user.displayName }}</strong>
                        <span>{{ 'users.roles.' + user.role | translate }}</span>
                      </div>
                      <button class="messages-compose__remove-button"
                        type="button"
                        [attr.aria-label]="'general.delete' | translate"
                        (click)="removeRecipient(user.guid)">
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </div>
                  } @empty {
                    <div class="messages-compose__recipient-empty">
                      {{ 'messagesWorkspace.compose.noRecipientsSelected' | translate }}
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="messages-compose__hint messages-compose__field--full">
                {{ 'messagesWorkspace.compose.allEmployeesHint' | translate:{ count: recipientOptions().length } }}
              </div>
            }

            <label class="messages-compose__field messages-compose__field--full">
              <span>{{ 'messagesWorkspace.compose.message' | translate }}</span>
              <textarea rows="8"
                formControlName="message"
                [placeholder]="'messagesWorkspace.compose.messagePlaceholder' | translate"></textarea>
            </label>
          </div>
        </form>
      } @else if (selectedEntry(); as entry) {
        <div class="messages-detail">
          <div class="messages-detail__header">
            <div>
              <div class="messages-detail__badges">
                @if (entry.kind === 'thread') {
                  <span class="messages-detail__badge">
                    {{ getThreadTypeKey(entry.thread) | translate }}
                  </span>
                } @else {
                  <span class="messages-detail__badge messages-detail__badge--group">
                    {{ 'messagesWorkspace.grouped.badge' | translate }}
                  </span>
                }
                @if (selectedThread()?.context; as context) {
                  <span class="messages-detail__context">
                    {{ context.title }}@if (context.subtitle) { - {{ context.subtitle }} }
                  </span>
                }
              </div>

              <h3>{{ entry.kind === 'group' ? entry.label : getThreadTitle(entry.thread) }}</h3>
              @if (entry.kind === 'group' && groupedReadSummary(); as readSummary) {
                <p>
                  {{ 'messagesWorkspace.grouped.readSummary' | translate:{ read: readSummary.read, total: readSummary.total } }}
                </p>
              } @else if (selectedThread(); as thread) {
                <p>{{ getThreadParticipantsLabel(thread) }} · {{ getReadSummaryLabel(thread) }}</p>
              }
            </div>

            @if (!mobile()) { <ng-container [ngTemplateOutlet]="archiveAction" /> }
          </div>

          <div class="messages-detail__body"
            [class.messages-detail__body--group]="entry.kind === 'group'">
            @if (entry.kind === 'group') {
              <aside class="messages-grouped">
                <strong>{{ 'messagesWorkspace.grouped.recipientsTitle' | translate }}</strong>
                <div class="messages-grouped__list">
                  @for (thread of entry.threads; track thread.guid) {
                    <button class="messages-grouped__item"
                      type="button"
                      [class.messages-grouped__item--active]="selectedThread()?.guid === thread.guid"
                      (click)="selectGroupedThread(thread)">
                      <div>
                        <strong>{{ thread.recipientName }}</strong>
                        <span>{{ displayDate(thread.updatedAt) | date:'dd.MM. HH:mm' }}</span>
                      </div>
                      <small>{{ getReadSummaryLabel(thread) }}</small>
                    </button>
                  }
                </div>
              </aside>
            }

            <div class="messages-chat">
              <div class="messages-chat__history" #messageHistory>
                @for (message of selectedThreadMessages(); track message.guid) {
                  <div class="messages-chat__bubble"
                    [class.messages-chat__bubble--mine]="isMine(message)">
                    @if (!isMine(message)) {
                      <span class="messages-chat__sender">
                        {{ message.senderName }}
                      </span>
                    }
                    <p>{{ message.content }}</p>
                    <span
                      class="messages-chat__time">{{ displayDate(message.createdAt) | date:'dd.MM.yyyy HH:mm' }}</span>
                  </div>
                }
              </div>

              <form class="messages-chat__composer"
                [formGroup]="replyForm">
                <textarea rows="3"
                  (input)="growReply($event)" formControlName="message"
                  [placeholder]="'messagesWorkspace.replyPlaceholder' | translate"></textarea>
                <button class="messages-workspace__primary-button"
                  type="button"
                  [disabled]="sending()"
                  (click)="sendReply()">
                  {{ (mobile() ? 'messagesWorkspace.actions.sendReply' : 'general.send') | translate }}
                </button>
              </form>
              @if (mobile()) {
                <div class="messages-chat__archive"><ng-container [ngTemplateOutlet]="archiveAction" /></div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="messages-workspace__empty-state">
          <div class="messages-workspace__empty-icon">
            <ion-icon name="chatbubbles-outline"></ion-icon>
          </div>
          <h3>{{ 'messagesWorkspace.empty.noSelectionTitle' | translate }}</h3>
          <p>{{ 'messagesWorkspace.empty.noSelectionDescription' | translate }}</p>
          <button class="messages-workspace__primary-button"
            type="button"
            (click)="openCompose()">
            {{ 'messagesWorkspace.actions.compose' | translate }}
          </button>
        </div>
      }
    </section>
  </div>
</app-modal-shell>